import { isObject, trimStart } from 'lodash';
import slugBlackList from '@wix/communities-blog-universal/dist/src/constants/slug-black-list';
import { getConfig } from './config';
import { BLOG_PAGE_ID, BLOG_POST_PAGE_ID } from '@wix/communities-blog-client-common/dist/src/constants/component-ids';
import { navigateToBlog, navigateToPostPage, navigateWithPostMessage } from './navigate-to-section';

export const appRoutes = slugBlackList.filter(slug => slug !== 'create-post');
const getFirstSlug = route =>
  trimStart(route, '/')
    .split('/')[0]
    .split('?')[0];

export const isAppRoute = (route, routes = appRoutes) => {
  const pathname = isObject(route) ? route.pathname : route;
  const slug = getFirstSlug(pathname);
  return slug === '' || routes.includes(slug);
};
export const isPostPageRoute = route => !isAppRoute(route);

const isBundleName = name => getConfig().bundleName === name;

export const isPostPageSettingsMobileBundle = () => isBundleName('post-page-settings-mobile');
export const isPostPageSettingsBundle = () => isBundleName('post-page-settings');
export const isAppBundle = () => isBundleName('app');
export const isPostPageBundle = () => isBundleName('post-page');

export const getLinkSectionInfo = route => {
  const { sectionUrl: feedSectionUrl, postPageSectionUrl } = getConfig();
  const isFeedRoute = isAppRoute(route);
  const isInSameSection = (isFeedRoute && isAppBundle()) || (!isFeedRoute && isPostPageBundle());
  const sectionUrl = isFeedRoute ? feedSectionUrl : postPageSectionUrl;
  const navigateToSection = isFeedRoute ? navigateToBlog : navigateToPostPage;
  const sectionId = isFeedRoute ? BLOG_PAGE_ID : BLOG_POST_PAGE_ID;
  const navigateToCustomRoute = navigateWithPostMessage(sectionId);

  return { isInSameSection, navigateToSection, sectionUrl, navigateToCustomRoute };
};
